import React, { FC } from 'react';
import styled from 'styled-components';
import { Order } from '../../../common/model/dto/order/order';
import { OrderDataUtils } from '../../../common/utils/services/order-data-utils';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvOrderCustomerSummaryProps {
  order: Order;
}

const OvOrderCustomerSummary: FC<OvOrderCustomerSummaryProps> = ({ order }) => (
  <>
    {OrderDataUtils.getCustomerShortName(order)}
    <Secondary>
      {OrderDataUtils.formatDateTime(order.ordered_at, 'DD MMM YYYY')}
    </Secondary>
    <Secondary>
      {OrderDataUtils.formatDateTime(order.ordered_at, 'HH:mm')}
    </Secondary>
  </>
);

export default OvOrderCustomerSummary;

const Secondary = styled.span`
  display: block;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
`;
